import React from 'react';
import { TextInput } from 'mintel-react-ui';
import FieldErrors from './FieldErrors';

type TextInputProps = { [key: string]: unknown };

export type TextInputWrapperProps = TextInputProps & {
  errors?: string[];
};

/**
 * Wrapper around TextInput component from MRUI that formats errors and adds a few common props.
 */
const TextInputWrapper = ({
  id,
  errors,
  ...baseProps
}: TextInputWrapperProps): JSX.Element => {
  const props: TextInputProps = {
    id,
    ...baseProps,
  };

  let errorId;
  if (errors && errors.length > 0) {
    errorId = `${id}-error`;
    props.showIcon = true;
    props.iconAlign = 'right';
    props.icon = { name: 'warning.svg' };
    props.ariaDescribedBy = errorId;
  }

  return (
    <div>
      <TextInput {...props} />
      {errors && errors.length > 0 && (
        <FieldErrors errors={errors} id={errorId} />
      )}
    </div>
  );
};

export default TextInputWrapper;
